import { motion } from "framer-motion";
import { Heart, Palette, BookOpen } from "lucide-react";

const STATS = [
  { icon: BookOpen, label: "Coloring books", value: "10" },
  { icon: Palette, label: "Designs per book", value: "70+" },
  { icon: Heart, label: "Large format", value: "8.5×11\"" },
];

export default function AboutWendy() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 sm:py-28 bg-[#118AB2]/8 border-y-2 border-[#073B4C] scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative order-2 lg:order-1"
        >
          <div className="border-2 border-[#073B4C] rounded-[2rem] overflow-hidden shadow-pop-lg rotate-[-2deg] bg-white">
            <img
              src="https://images.unsplash.com/photo-1752649935868-b21cb7640efc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxjaGVlcmZ1bCUyMHdvbWFuJTIwYXJ0aXN0JTIwcGFpbnRpbmd8ZW58MHx8fHwxNzgzODE1MzMyfDA&ixlib=rb-4.1.0&q=85"
              alt="Wendy in her art studio"
              loading="lazy"
              className="w-full aspect-[4/3] object-cover"
            />
          </div>
          <span className="absolute -bottom-5 -right-3 font-display text-2xl bg-[#FFD166] text-[#073B4C] border-2 border-[#073B4C] rounded-full px-5 py-2 shadow-pop rotate-6">
            Hi, I'm Wendy!
          </span>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="order-1 lg:order-2"
        >
          <span className="font-heading font-semibold text-sm text-[#EF476F] uppercase tracking-wider">
            About the artist
          </span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-2 text-[#073B4C]">
            Drawing joy, one page at a time
          </h2>
          <p className="font-body text-lg text-[#073B4C]/75 mt-5">
            I'm an illustrator on a mission to make coloring feel like a warm
            hug. Each book is hand made with AI, packed with whimsical
            characters, calming patterns, and tiny surprises on every page.
          </p>
          <p className="font-body text-lg text-[#073B4C]/75 mt-4">
            Whether you're a busy grown-up looking to unwind or a little artist
            just getting started, there's a page in here waiting for your colors.
          </p>

          <div className="grid grid-cols-3 gap-4 mt-9">
            {STATS.map((s) => (
              <div
                key={s.label}
                data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-white border-2 border-[#073B4C] rounded-2xl p-4 shadow-pop text-center"
              >
                <s.icon className="mx-auto text-[#06D6A0]" size={24} strokeWidth={2.5} />
                <div className="font-heading font-bold text-2xl text-[#073B4C] mt-2">
                  {s.value}
                </div>
                <div className="font-body text-xs text-[#073B4C]/60">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
